import { string, object, func, bool } from 'prop-types'
import { Fragment } from 'react'
import { renderIcon } from '@opallabs/kuiper'
import { AccountName } from '../../../../../AccountName'
import { SMSPreview } from '../../SMSPreview'
import { styles } from './styles.js'

export const MobileSingle = ({
  accountName,
  asset,
  content,
  isPresenting,
  onContentChange,
  onExpandAsset,
  onRemoveAsset,
  readOnly,
}) => (
  <Fragment>
    <div css={styles.headerWrapper}>
      <div>
        {renderIcon('sms-west-chevron', {
          height: 10,
          width: 10,
          ariaMode: 'hidden',
        })}
      </div>
      <AccountName name={accountName} size={18} color="#000" />
      <div>
        {renderIcon('sms-more', { height: 10, width: 10, ariaMode: 'hidden' })}
      </div>
    </div>
    <div css={styles.smsPreviewWrapper}>
      <SMSPreview
        asset={asset}
        content={content}
        readOnly={readOnly}
        isPresenting={isPresenting}
        onContentChange={onContentChange}
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
      />
    </div>
    <div css={styles.messageBoxWrapper}>
      <div css={styles.messageBox}>
        <div css={styles.messageBoxInner}>
          <div>
            {renderIcon('sms-emoji', {
              height: 20,
              width: 20,
              ariaMode: 'hidden',
            })}
          </div>
          <div css={styles.messageBoxText}>Send Message...</div>
        </div>
        <div css={styles.messageBoxInner}>
          {renderIcon('sms-plus', {
            height: 18,
            width: 18,
            ariaMode: 'hidden',
          })}
        </div>
      </div>
    </div>
  </Fragment>
)

MobileSingle.propTypes = {
  accountName: string,
  asset: object,
  content: string,
  isPresenting: bool,
  onContentChange: func,
  onExpandAsset: func,
  onRemoveAsset: func,
  readOnly: bool,
}
